import {
  IPage,
  INameState
} from '../types'


export function getNameState(page: IPage, name: string): INameState {
  if (page.checked) {
    if (page.taken.has(name)) {
      return 'taken'
    } else {
      return 'available'
    }
  } else {
    return 'pending'
  }
}


// WEBPACK FOOTER //
// ./src/service/page.ts